import React from "react";
import { ShieldCheck, HelpCircle, AlertTriangle } from "lucide-react";

export default function FAQ() {
  const faqs = [
    {
      q: "What does PinMyDoc do?",
      a: "PinMyDoc helps people discover family doctors, walk-in clinics, pediatric care, and primary care providers in Ontario.",
    },
    {
      q: "Is provider availability guaranteed?",
      a: "No. Clinic availability can change anytime. Users must call the clinic directly before visiting or applying.",
    },
    {
      q: "Where does the information come from?",
      a: "Information may come from public clinic information, clinic websites, public directories, admin review, and community updates.",
    },
    {
      q: "Can I suggest an update to provider information?",
      a: "Yes. Use the report option on a provider card or profile to share updated availability, clinic details, or other helpful corrections.",
    },
    {
      q: "Does this app provide medical advice?",
      a: "No. This platform is for discovery and general information only. It does not provide diagnosis, treatment, medical advice, or emergency guidance.",
    },
    {
      q: "How do I contact support?",
      a: "For technical support, email support@techdroid.ca",
    },
  ];

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="rounded-[2rem] bg-white border border-slate-100 shadow-xl p-6 sm:p-10">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-2xl bg-[#EEF5FB] flex items-center justify-center">
            <HelpCircle className="w-6 h-6 text-[#356DFF]" />
          </div>

          <div>
            <h1 className="text-3xl sm:text-4xl font-black text-slate-900">
              FAQ & Support
            </h1>
            <p className="mt-2 text-slate-600">
              Common questions about using PinMyDoc.
            </p>
          </div>
        </div>

        <div className="mt-8 space-y-4">
          {faqs.map((item) => (
            <div
              key={item.q}
              className="rounded-2xl border border-slate-200 bg-slate-50 p-5"
            >
              <h3 className="font-bold text-slate-900">{item.q}</h3>
              <p className="mt-2 text-sm leading-7 text-slate-600">{item.a}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 rounded-2xl border border-red-200 bg-red-50 p-5">
          <div className="flex items-start gap-3">
            <AlertTriangle className="w-5 h-5 text-red-600 mt-0.5" />
            <p className="text-sm leading-7 text-red-700">
              For emergencies, call 911 or go to the nearest emergency
              department immediately. Do not delay urgent medical care based on
              information shown in this app.
            </p>
          </div>
        </div>

        <div className="mt-5 rounded-2xl border border-[#B7E4C7] bg-[#F0FFF4] p-5">
          <div className="flex items-start gap-3">
            <ShieldCheck className="w-5 h-5 text-[#2D6A4F] mt-0.5" />
            <p className="text-sm leading-7 text-slate-700">
              Always confirm clinic hours, availability, location, and patient
              acceptance directly with the clinic.
            </p>
          </div>
        </div>

        <div className="mt-6 rounded-2xl border border-slate-200 bg-white p-5">
          <p className="text-sm text-slate-600">
            Technical support:{" "}
            <a
              href="mailto:support@techdroid.ca?subject=PinMyDoc%20Support"
              className="font-semibold text-[#356DFF]"
            >
              support@techdroid.ca
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}